  const dataSelectType = [
    {
      value: "vsfhp",
      label: "เช่าซื้อ", 
    },
    {
      value: "rpsl",
      label: "p-loan",
    },
  ];
export default dataSelectType;